import { render } from "./TvmColorSelection.vue?vue&type=template&id=c88cf494&scoped=true"
import script from "./TvmColorSelection.js?vue&type=script&lang=js&external"
export * from "./TvmColorSelection.js?vue&type=script&lang=js&external"

import "./TvmColorSelection.vue?vue&type=style&index=0&id=c88cf494&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c88cf494"],['__file',"src/components/ChatWidget/TvmColorSelection/TvmColorSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c88cf494"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c88cf494', __exports__)) {
    api.reload('c88cf494', __exports__)
  }
  
  module.hot.accept("./TvmColorSelection.vue?vue&type=template&id=c88cf494&scoped=true", () => {
    api.rerender('c88cf494', render)
  })

}


export default __exports__